import CloseIcon from '@mui/icons-material/Close';
import { Box, Divider, Drawer, IconButton, ScopedCssBaseline, type Theme, Typography } from '@mui/material';

type FilterDrawerProps = {
  readonly open: boolean;
  readonly onClose?: () => void;
  readonly children: React.ReactNode;
};

export const drawerZIndex = (theme: Theme) => theme.zIndex.modal + 1;

export const FilterDrawer = ({ open, onClose, children }: FilterDrawerProps) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={onClose}
    sx={{ zIndex: drawerZIndex }}
    slotProps={{
      paper: {
        sx: {
          top: '72px',
          right: '8px',
          p: 2,
          borderRadius: '10px',
          minHeight: 'calc(100vh - 114px)',
          height: 'calc(100vh - 114px)',
          maxHeight: 'calc(100vh - 114px)',
          width: '430px',
          overflowY: 'hidden',
        },
      },
    }}
  >
    <Box display="flex" flexDirection="column" justifyContent="space-between">
      <ScopedCssBaseline>
        <Box display="flex" flexDirection="column" gap={1} sx={{ backgroundColor: 'white', zIndex: 1, pb: 1 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="headingXs">Alle Filter</Typography>
            <IconButton size="small" sx={{ border: '1px solid lightgrey', borderRadius: '50%' }} onClick={onClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Divider flexItem />
        </Box>
        {children}
      </ScopedCssBaseline>
    </Box>
  </Drawer>
);
